const collapse = ( { el, timeOut, onShow, onShown, onHide, onHidden } ) => {
	if ( ! el ) {
		return console.error( 'Missing ', { el: !! el } );
	}
	/* easy class access */
	const [ hidden, collapsing ] = [
		'fndry-collapse--hidden',
		'fndry-collapse--collapsing',
	];

	/* get our initial state */
	const isHidden = el.classList.contains( hidden );

	const cleanup = ( e ) => {
		/* abort if we're being used as an event and the transitionend event target doesn't match our el */
		if ( e.target !== el ) {
			return;
		}

		/* remove event listener if there is one i guess*/
		if ( e ) {
			el.removeEventListener( 'transitionend', cleanup );
		}

		// el.style.height = '';
		// el.style.width = '';
		el.classList.remove( collapsing );

		if ( ! isHidden ) {
			el.classList.add( hidden );
			if ( onHidden && typeof onHidden === 'function' ) {
				onHidden.call( this );
			}
		} else if ( onShown && typeof onShown === 'function' ) {
			onShown.call( this );
		}
	};

	if ( isHidden ) {
		if ( onShow && typeof onShow === 'function' ) {
			onShow.call( this );
		}
		el.classList.remove( hidden );
		el.classList.add( collapsing );
		if ( timeOut ) {
			setTimeout( () => {
				// el.style.height = '';
				// el.style.width = '';
				el.classList.remove( collapsing );
				if ( onShown && typeof onShown === 'function' ) {
					onShown.call( this );
				}
			}, timeOut );
		} else {
			el.addEventListener( 'transitionend', cleanup );
			setTimeout( () => {
				el.style.height = `${ el.firstElementChild.scrollHeight }px`;
				el.style.width = `${ el.firstElementChild.scrollWidth }px`;
			}, 1 );
		}
	} else if ( ! isHidden ) {
		if ( onHide && typeof onHide === 'function' ) {
			onHide.call( this );
		}
		el.style.height = '';
		el.style.width = '';
		el.classList.add( collapsing );
		if ( timeOut ) {
			el.style.height = '';
			el.style.width = '';
			setTimeout( () => {
				el.classList.add( hidden );
				el.classList.remove( collapsing );
				if ( onHidden && typeof onHidden === 'function' ) {
					onHidden.call( this );
				}
			}, timeOut );
		} else {
			el.addEventListener( 'transitionend', cleanup );
			setTimeout( () => {
				el.style.height = '';
				el.style.width = '';
			}, 1 );
		}
	}
};

document.querySelectorAll( '.fs-pillars' ).forEach( ( wrap ) => {
	const images = wrap.querySelectorAll( '.fs-pillar-image' );
	const pillars = wrap.querySelectorAll( '.fs-pillar' );
	const reset = wrap.querySelector( '.fs-pillars__reset' );

	reset.addEventListener( 'click', () => {
		pillars.forEach( ( pillar ) => {
			if ( pillar.classList.contains( 'active' ) ) {
				pillar.classList.remove( 'active' );
				collapse( {
					el: pillar.querySelector( '.fs-pillar__content' ),
					onHidden: () => {
						maybeHideReset();
						pillar.querySelector( '[aria-expanded="true"]' ).setAttribute( 'aria-expanded', 'false' );
						images.forEach( ( img, index ) => {
							if ( index !== 0 ) {
								img.classList.add( 'fs-pillar-image--hidden' );
								img.style.zIndex = '-2';
							}
						} );
					},
				} );
			}
		} );

		wrap.querySelector( '.fs-pillars__track-wrap' ).scrollTo( {
			top: 0,
			left: 0,
			behavior: 'smooth',
		} );
	} );

	const maybeHideReset = () => wrap.querySelectorAll( '.active' ).length === 0 ? reset.setAttribute( 'disabled', 'disabled' ) : null;

	pillars.forEach( ( pillar, i ) => {
		// calc height and width
		const label = pillar.querySelector( '.fs-pillar__label' );
		label.addEventListener( 'click', ( e ) => {
			wrap.querySelectorAll( '.fs-pillar__content:not(.fndry-collapse--hidden)' ).forEach( ( hidden ) => {
				if ( hidden.parentElement !== pillar ) {
					collapse( {
						el: hidden,
						onHidden: () => {
							hidden.parentElement.classList.remove( 'active' );
							hidden.previousElementSibling.setAttribute( 'aria-expanded', 'false' );
							maybeHideReset();
						},
					} );
				}
			} );
			collapse( {
				el: pillar.querySelector( '.fs-pillar__content' ),
				onShow: () => {
					pillar.classList.add( 'active' );
					label.setAttribute( 'aria-expanded', 'true' );
					images[ i ].classList.remove( 'fs-pillar-image--hidden' );
					images[ i ].style.zIndex = '-1';
					images.forEach( ( img, index ) => {
						if ( index !== i ) {
							img.style.zIndex = '-2';
						}
					} );
					reset.removeAttribute( 'disabled' );
				},
				onShown: () => {
					images.forEach( ( img, index ) => {
						if ( index !== i && index > 0 ) {
							// dont remove the default
							img.classList.add( 'fs-pillar-image--hidden' );
						}
					} );
					// just to adjust for resizing
					if ( window.innerWidth < 735 ) {
						pillar.scrollIntoView( {
							behavior: 'smooth',
							inline: 'start',
							block: 'end',
							container: 'nearest',
						} );
					}
				},
				onHidden: () => {
					pillar.classList.remove( 'active' );
					label.setAttribute( 'aria-expanded', 'false' );
					if ( i !== 0 ) {
						images[ i ].classList.add( 'fs-pillar-image--hidden' );
						images[ i ].style.zIndex = '-2';
					}
					maybeHideReset();
				},
			} );
		} );
	} );
} );